var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", { staticClass: "modal-title" }, [_vm._v(" EMBED URL ")]),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_embed_url.title.$error } },
        [
          _c("label", [_vm._v(" Title ")]),
          _vm._v(" "),
          _c("j-input", {
            attrs: { "max-length": 255, placeholder: "Title" },
            model: {
              value: _vm.$v.data_embed_url.title.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_embed_url.title, "$model", $$v)
              },
              expression: "$v.data_embed_url.title.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.data_embed_url.url.$error } },
        [
          _c("label", [_vm._v(" URL ")]),
          _vm._v(" "),
          _c("j-input", {
            attrs: { placeholder: "https://" },
            model: {
              value: _vm.$v.data_embed_url.url.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.data_embed_url.url, "$model", $$v)
              },
              expression: "$v.data_embed_url.url.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", [
            _c(
              "div",
              { staticClass: "float-to-right" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn gray m__r--5",
                    on: { click: _vm.closeEmbedUrl }
                  },
                  [_vm._v("\n          Close\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  { staticClass: "btn blue", on: { click: _vm.saveEmbedUrl } },
                  [_vm._v("\n          Save\n        ")]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "warning-message" }, [
      _c("img", { attrs: { src: require("@/assets/icon/warning.svg") } }),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-column" }, [
        _c("p", { staticClass: "warning-title" }, [_vm._v("Information")]),
        _vm._v(" "),
        _c("p", { staticClass: "warning-text" }, [
          _vm._v(
            "\n        URL must use HTTPS (Hypertext Transfer Protocol Secure)\n      "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-623fca7d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-623fca7d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/pages-component/jEmbedUrlSetup.vue
// module id = null
// module chunks = 